import { render, staticRenderFns } from "./SignupSuccess.vue?vue&type=template&id=65c2279a&scoped=true&"
import script from "./SignupSuccess.vue?vue&type=script&lang=js&"
export * from "./SignupSuccess.vue?vue&type=script&lang=js&"
import style0 from "./SignupSuccess.vue?vue&type=style&index=0&id=65c2279a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65c2279a",
  null
  
)

export default component.exports